import React, { memo, useEffect, useState } from "react";
import { Alert, Button, DatePicker, Form, Input, Select } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import moment from "moment";
import { updateUserInfo } from "../../../api/client";
import { useDispatch } from "react-redux";

const { Option } = Select;

const Index = ({ setUserPopDetails, setIsModalOpen }) => {
  const dispatch = useDispatch();
  const [isDisable, setIsDisable] = useState(true)
  const onFinish = async (values) => {
    console.log("Success:", values);
    updateUserInfo(values, dispatch);
    console.log("date", moment(values.date).format("YYYY-MM-DD"));
    setUserPopDetails(values);
    setIsModalOpen(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    const userInformation = localStorage.getItem("emailForSignIn") || "";
    console.log("userInformation", userInformation);
  });
  const checkDob = (date, dateString) => {
    setIsDisable(false);
    console.log("Value", date, dateString);

    const date1 = new Date(dateString);
    const date2 = new Date();
    let yearsDiff = date2.getFullYear() - date1.getFullYear();
    console.log("yearsDiff", yearsDiff);
    // console.log(diffTime + " milliseconds");
    // console.log(diffDays + " days");
    if (yearsDiff >= 18) {
      setIsDisable(true);
    
    }else{
      setIsDisable(false);
    }
  };
  console.log("---------------------CHK----------------------");
  return (
    <>
      <Container>
        <Row className="d-flex justify-content-center align-items-center">
          <Col lg={12}>
            <Alert
              description="Introduce yourself to your psychic so they can provide you with the most accurate reading."
              type="info"
              showIcon
            />
            <br />
            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                name="username"
                label="User Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter your user name!",
                  },
                  {
                    message: "Minimum (3)",
                    min: 3,
                  },
                ]}
              >
                <Input className="w-100" />
              </Form.Item>
              <Form.Item
                name="date"
                label="Date of Birth"
                rules={[
                  {
                    required: true,
                    message: "Please input your date of birth!",
                  },
                ]}
                validateStatus={isDisable === false ? "error" : ''}
                help={isDisable === false ? "User should be atleast 18 years" : ''}
              >
                <DatePicker className="w-100" onChange={checkDob} />
              </Form.Item>
              <Form.Item
                name="gender"
                label="Gender"
                // rules={[
                //   {
                //     required: true,
                //   },
                // ]}
              >
                <Select
                  placeholder="Select a option and change input text above"
                  // onChange={this.onGenderChange}
                  allowClear
                >
                  <Option value="Male">Male</Option>
                  <Option value="Female">Female</Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  offset: 12,
                  span: 10,
                }}
              >
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default memo(Index);
